import { trackEvent } from "./tiktokPixel";

export const SERVICE_IDS = ["import", "europe", "buy"];
export const SERVICE_AVAILABILITY = { import: "available", europe: "available", buy: "coming_soon" };
export const SELECT_SERVICE_EVENT = "gtx:select-service";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "ttclid"];

export function captureCampaignParams() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 120);
  });
  if (Object.keys(found).length) sessionStorage.setItem("gtx_campaign", JSON.stringify(found));
  return params.get("service");
}

export function getCampaignParams() {
  try {
    return JSON.parse(sessionStorage.getItem("gtx_campaign") || "{}");
  } catch {
    return {};
  }
}

export function selectService(serviceId, { scroll = true, source = "cta" } = {}) {
  window.dispatchEvent(new CustomEvent(SELECT_SERVICE_EVENT, { detail: serviceId }));
  if (SERVICE_IDS.includes(serviceId)) trackEvent("ClickButton", { content_type: "service", content_id: serviceId, content_name: `cta_${source}` });
  if (scroll) document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export const track = {
  serviceViewed: (id) => trackEvent("ViewContent", { content_type: "service", content_id: id }),
  formStart: (id) => trackEvent("FormStart", { content_type: "service", content_id: id || "unsure" }),
  evaluationSubmitted: (id) => trackEvent("SubmitForm", { content_type: "evaluation", content_id: id || "unsure" }),
  interestRegistered: (id) => trackEvent("RegisterInterest", { content_type: "interest", content_id: id }),
  calendlyClick: (where) => trackEvent("ClickButton", { content_type: "calendly", content_id: "calendly-30min", content_name: where }),
};
